import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Grid } from '@mui/material';

import ChatAppBody from './layout/ChatAppBody';
import { useGetContactsQuery } from 'app/features/chat/chatApi';
import StyledHeader from 'app/components/shared/StyledHeader';
import ChatPrimary from './ChatPrimary';
import ChatSecondary from './ChatSecondary';
import useChatFunctions from 'app/features/chat/hooks/useChatFunctions';

const ChatContainer = () => {
  const { data: contactsData } = useGetContactsQuery();
  const { slug } = useParams();

  const { setCurrentContactBySlug } = useChatFunctions();

  useEffect(() => {
    if (contactsData) {
      // we might have a slug from the url, but if not
      // we can just take the first contact from our list
      // and set it as current
      setCurrentContactBySlug(slug || contactsData.contacts[0]?.other_user.slug);
    }
  }, [contactsData]);

  return (
    <ChatAppBody>
      <StyledHeader data-test-id="template-shell-header">
        Chat
      </StyledHeader>
      <Grid
        container
        sx={{ overflow: 'hidden' }}
      >
        <Grid item sm={4} xs={12}>
          <ChatSecondary contactsData={contactsData} />
        </Grid>
        <Grid item sm={8} xs={12}>
          <ChatPrimary />
        </Grid>
      </Grid>
    </ChatAppBody>
  );
};

export default ChatContainer;
